import React, { useState, Fragment, useEffect } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { Link } from 'react-router-dom';

import Swal from 'sweetalert2';
import OtherFeedbacks from './OtherFeedbacks';
import { useDispatch, useSelector } from 'react-redux';
import { changeStatusApplication } from '../../redux/actions/applications/changeApplicationStatus';
import { resetChangeApplicationStatusList, resetChangeStatusApplication, resetDeleteApplicationList } from '../../redux/slices/application.slice';
import { changeApplicationStatusList } from '../../redux/actions/applications/changeApplicationStatusList';
import { deleteApplicationList } from '../../redux/actions/applications/deleteApplicationList';
import { Modal } from 'antd';
import ProfileIndex from '../../pages/Profile/ProfileIndex';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

function UnProcessedFeedBackList({ form, activeTab, currentItems, onFetch, vacancyId }) {
  const userChecked = form.watch('userChecked');
  const [allChecked, setAllChecked] = useState(false);
  const [actionChecked, setActionChecked] = useState(null);
  const [openUser, setOpenUser] = useState();
  const isAllChecked = (list, updateList) => {
    return list?.filter?.((item) => updateList[item.id])?.length == list?.length;
  };
  const {
    getVacancySingle: { data: getVacancySingleData, error: getVacancySingleError, loading: getVacancySingleLoading },
  } = useSelector((state) => state.dashboard);
  const dispatch = useDispatch();
  const handleProcess = (applicationId) => {
    Swal.fire({
      title: 'Вы действительно переместить отклик в обработанные?',
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Да',
      cancelButtonText: 'Нет',
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(changeStatusApplication(applicationId));
      }
    });
  };

  const {
    changeStatusApplication: { data: changeStatusApplicationData, error: changeStatusApplicationError, loading: changeStatusApplicationLoading },
    changeApplicationStatusList: { data: changeApplicationStatusListData, error: changeApplicationStatusListError, loading: changeApplicationStatusListLoading },
    deleteApplicationList: { data: deleteApplicationListData, error: deleteApplicationListError, loading: deleteApplicationListLoading },
  } = useSelector((state) => state.application);
  useEffect(() => {
    if (deleteApplicationListData) {
      Swal.fire({
        title: actionChecked == 'deletion_list' ? 'Выбранные отклики удалены' : 'Отклик удален',
        showConfirmButton: false,
        timer: 1000,
        timerProgressBar: true,
      });
      onFetch();
      form.setValue('userChecked', {});
      dispatch(resetDeleteApplicationList());
    }
  }, [deleteApplicationListData]);
  useEffect(() => {
    if (changeApplicationStatusListData) {
      Swal.fire({
        title: actionChecked == 'processing_list' ? 'Выбранные отклики взяты в работу' : actionChecked == 'processed_list' ? 'Выбранные отклики перемещены в обработанные' : 'Отклик взят в работу',
        showConfirmButton: false,
        timer: 1000,
        timerProgressBar: true,
      });
      onFetch();
      form.setValue('userChecked', {});
      dispatch(resetChangeApplicationStatusList());
    }
  }, [changeApplicationStatusListData]);

  useEffect(() => {
    if (changeStatusApplicationData) {
      Swal.fire({
        title: 'Отклик перемещен в обработанные',
        showConfirmButton: false,
        timer: 1000,
        timerProgressBar: true,
      });
      onFetch();
      dispatch(resetChangeStatusApplication());
    }
  }, [changeStatusApplicationData]);

  const handleDelete = () => {
    Swal.fire({
      title: 'Вы действительно хотите удалить отклик?',
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Да',
      cancelButtonText: 'Нет',
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'Отклик удален',
          showConfirmButton: false,
          timer: 1000,
          timerProgressBar: true,
        });
      }
    });
  };
  if (!currentItems?.length) {
    return (
      <div className="relative h-[150px]">
        {' '}
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 font-semibold ">Откликов не найдено</div>
      </div>
    );
  }
  return (
    <div className="flex flex-col w-full mb-[16px]">
      <div className="">
        <div className="p-2 min-w-full inline-block align-middle">
          <div className="border rounded-lg  justify-start">
            <table className="min-w-full items-center align-middle divide-y divide-gray-200 ">
              <thead>
                <tr>
                  <th scope="col" className="pr-2 py-3 text-start text-[16px] font-medium uppercase">
                    <input
                      id="select_all"
                      name="all"
                      type="checkbox"
                      className="h-3 w-3 rounded border-gray-300 text-blue-500 focus:ring-blue-500"
                      value={allChecked}
                      checked={allChecked}
                      onClick={(e) => {
                        if (e.target.checked) {
                          let allChecked = {};
                          currentItems?.map((item) => {
                            allChecked = { ...allChecked, [item.id]: true };
                          });
                          form.setValue('userChecked', { ...userChecked, ...allChecked });
                          setAllChecked(true);
                        } else {
                          currentItems?.map((item) => {
                            delete userChecked[item.id];
                          });
                          form.setValue('userChecked', userChecked);
                          setAllChecked(false);
                        }
                      }}
                    />
                  </th>
                  <th scope="col" className=" px-2 py-3 text-start text-[16px] font-medium uppercase">
                    №
                  </th>
                  <th scope="col" className=" px-2 py-3 text-start text-[16px] font-medium uppercase">
                    ФИО
                  </th>
                  <th>
                    {userChecked && Object.keys(userChecked)?.length ? (
                      <Menu as="div" className="relative inline-block text-left">
                        <div>
                          <Menu.Button className="inline-flex w-full justify-center border-0 gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900">
                            Действия
                            <svg xmlns="http://www.w3.org/2000/svg" width="12px" height="12px" fill="currentColor" className="bi bi-caret-down-fill self-center" viewBox="0 0 16 16">
                              <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"></path>
                            </svg>
                          </Menu.Button>
                        </div>

                        <Transition as={Fragment} enter="transition ease-out duration-100" enterFrom="transform opacity-0 scale-95" enterTo="transform opacity-100 scale-100" leave="transition ease-in duration-75" leaveFrom="transform opacity-100 scale-100" leaveTo="transform opacity-0 scale-95">
                          <Menu.Items className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                            <div className="py-1">
                              {activeTab == 'processed' && getVacancySingleData?.is_hr ? (
                                <Menu.Item>
                                  {({ active }) => (
                                    <Link onClick={() => {}} className={classNames(active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm')}>
                                      Отправить контрагенту
                                    </Link>
                                  )}
                                </Menu.Item>
                              ) : activeTab == 'unprocessed' ? (
                                <>
                                  {' '}
                                  <Menu.Item>
                                    {({ active }) => (
                                      <Link
                                        onClick={() => {
                                          setActionChecked('processing_list');
                                          dispatch(
                                            changeApplicationStatusList({
                                              status: 'processing',
                                              applications: Object.keys(userChecked)
                                                ?.filter((key) => userChecked[key])
                                                .map((key) => key),
                                            }),
                                          );
                                        }}
                                        className={classNames(active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm')}>
                                        Взять в работу
                                      </Link>
                                    )}
                                  </Menu.Item>
                                  <Menu.Item>
                                    {({ active }) => (
                                      <Link
                                        onClick={() => {
                                          setActionChecked('processed_list');
                                          dispatch(
                                            changeApplicationStatusList({
                                              status: 'processed',
                                              applications: Object.keys(userChecked)
                                                ?.filter((key) => userChecked[key])
                                                .map((key) => key),
                                            }),
                                          );
                                        }}
                                        className={classNames(active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm')}>
                                        Обработать
                                      </Link>
                                    )}
                                  </Menu.Item>
                                </>
                              ) : (
                                <></>
                              )}

                              <Menu.Item>
                                {({ active }) => (
                                  <Link
                                    onClick={() => {
                                      setActionChecked('deletion_list');
                                      dispatch(
                                        deleteApplicationList({
                                          applications: Object.keys(userChecked)
                                            ?.filter((key) => userChecked[key])
                                            .map((key) => key),
                                        }),
                                      );
                                    }}
                                    className={classNames(active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm')}>
                                    Удалить
                                  </Link>
                                )}
                              </Menu.Item>
                            </div>
                          </Menu.Items>
                        </Transition>
                      </Menu>
                    ) : (
                      ''
                    )}
                  </th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody className={`items-center align-middle`}>
                {currentItems &&
                  currentItems.map((item) => (
                    <tr key={item.id} className="">
                      <td className="pr-2 py-4 whitespace-nowrap text-sm text-gray-800 h-[60px]">
                        <input
                          name={item.id}
                          type="checkbox"
                          aria-checked={'false'}
                          // onClick={handleCheck}
                          className="select_checkbox h-3 w-3 rounded border-gray-300 text-blue-500 focus:ring-blue-500"
                          defaultChecked={userChecked[item.id]}
                          checked={!!userChecked[item.id]}
                          onChange={(e) => {
                            let updateChecked;
                            if (e.target.checked) {
                              updateChecked = { ...userChecked, [item.id]: true };
                              form.setValue('userChecked', updateChecked);
                            } else {
                              delete userChecked[item.id];
                              updateChecked = userChecked;
                              form.setValue('userChecked', userChecked);
                            }
                            setAllChecked(isAllChecked(currentItems, updateChecked));
                          }}
                        />
                      </td>
                      <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-800 h-[60px]">{item.id}</td>
                      <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-800 h-[60px]">
                        <div
                          className="cursor-pointer"
                          onClick={() => {
                            setOpenUser(item?.candidate?.id);
                          }}>
                          {item.candidate?.full_name}
                        </div>
                      </td>
                      {activeTab == 'processed' ? (
                        <>
                          <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-800 w-[115px] h-[60px]"></td>
                          <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-800 w-[163px] h-[60px]"></td>
                          <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-800 h-[60px]">
                            <button
                              className={`flex w-fit px-2.5 py-1 rounded-md bg-gray-300`}
                              onClick={() => {
                                setActionChecked('deletion');
                                dispatch(
                                  deleteApplicationList({
                                    applications: [item.id],
                                  }),
                                );
                              }}>
                              Удалить
                            </button>
                          </td>
                        </>
                      ) : (
                        <>
                          {' '}
                          <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-800 h-[60px]">
                            {item.status === 'processing' ? (
                              <button className={`flex w-fit px-2.5 py-1 rounded-md bg-green-500`} name={item.num}>
                                Взято в работу
                              </button>
                            ) : (
                              <button
                                className={`flex w-fit px-2.5 py-1 rounded-md bg-gray-300`}
                                name={item.num}
                                onClick={() => {
                                  setActionChecked('processing');
                                  dispatch(
                                    changeApplicationStatusList({
                                      status: 'processing',
                                      applications: [item.id],
                                    }),
                                  );
                                }}>
                                Взять в работу
                              </button>
                            )}
                          </td>
                          <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-800 h-[60px]">
                            <OtherFeedbacks userId={item?.candidate?.id} count={item?.candidate?.total_applications - 1} appId={item?.id} />
                          </td>
                          <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-800 h-[60px]">
                            <button
                              className={`flex w-fit px-2.5 py-1 rounded-md bg-gray-300`}
                              onClick={() => {
                                handleProcess(item.id);
                              }}>
                              Обработать
                            </button>
                          </td>
                        </>
                      )}
                    </tr>
                  ))}
              </tbody>
              {/* <tfoot>
                <tr className="h-[110px]"></tr>
              </tfoot> */}
            </table>
          </div>
        </div>
      </div>
      <Modal
        className="select-user-modal"
        style={{ height: 'calc(100vh - 40px)' }}
        title={``}
        centered
        open={openUser}
        width={'100%'}
        onCancel={() => {
          setOpenUser(null);
        }}
        footer={['']}>
        <ProfileIndex userId={openUser} isEditComment vacancyId={vacancyId} />
      </Modal>
    </div>
  );
}

export default UnProcessedFeedBackList;
